import React from 'react';
import { Modal, Button, Table, Popconfirm, Icon, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import AddResponseHospital from './AddResponseHospital';

class PreviewHospitalModal extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
        searchParam: {},
    };

    loadData = () => {
        this.setState({ loading: true });
        const { pagination, searchParam } = this.state;
        const { ssuMemberId } = searchParam;
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuMemberHospital,
            data: {
                offset: pagination.current,
                limit: pagination.pageSize,
                ssuMemberId,
            },
            dataType: 'json',
            doneResult: data => {
                const pagination = { ...this.state.pagination };
                pagination.total = data.totalCount;
                this.setState({
                    data: data.ssuMemberHospitalList,
                    loading: false,
                    pagination,
                });
            }
        }
        $.sendRequest(options)
    };

    show = record => {
        this.setState({
            data: [],
            pagination: {
                pageSize: 10,
                current: 1,
            },
            searchParam: {
                ssuMemberId: record.ssuMemberId,
                userCompellation: record.userCompellation
            },
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    getColumns = () => {
        const { record: { canEdit, userId } } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 150,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: '等级',
            dataIndex: 'hospitalLevel',
            key: 'hospitalLevel',
            width: 90,
        }, {
            title: '省',
            dataIndex: 'hospitalProvince',
            key: 'hospitalProvince',
            width: 90,
        }, {
            title: '市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',
            width: 90,
        }, {
            title: '详细地址',
            dataIndex: 'hospitalAddress',
            key: 'hospitalAddress',
            width: 150,
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 150,
        }];

        const { curRole, userId: id } = sessionStorage;

        if (canEdit && !(curRole == 'VP' || curRole == 'FIN' || curRole == 'BA' || curRole == 'BAL')) {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                width: 60,
                render: (text, record) => {
                    return (
                        <span>
                            <Popconfirm
                                title='确定删除该医院?'
                                icon={<Icon type="close-circle-o" style={{ color: 'red' }} />}
                                onConfirm={() => this.delete(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <a disabled={curRole == 'CRC' && userId == id}>删除</a>
                            </Popconfirm>
                        </span>
                    )
                }
            });
        }
        return columns;
    }


    getDataSource = () => {
        const dataSource = [];
        const { data, pagination } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: (pagination.current - 1) * 10 + index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    handleTableChange = (pagination, filter, sorter) => {
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current) {
            pager.current = 1;
        } else {
            pager.current = pagination.current;
        }
        this.setState({
            pagination: pager,
        }, () => {
            this.loadData();
        });
    }

    delete = (record) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.delSsuMemberHospital}`,
            data: {
                ssuMemberId: record.ssuMemberId,
                hospitalId: record.hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    addHospital = () => {
        const { searchParam: { ssuMemberId } } = this.state;
        this.addResponseHospitalRef.show(ssuMemberId);
    }
    
    render() {
        const { visible, loading, pagination, searchParam: { userCompellation }, record: { canEdit, userId } } = this.state;
        const { curRole, userId: id } = sessionStorage;
        return (
            <Modal
                title="负责医院"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal inv-detail"
                wrapClassName="vertical-center-modal"
                width="1040px"
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ background: '#fff', padding: '10px 30px' }}>
                    <ul>
                        <li>
                            <div className="filter-bar">
                                <div className="filter-bar-investigation" style={{ width: '100%' }}>
                                    <h3 style={{ float: 'left' }}>SSU人员：{userCompellation}</h3>
                                    {
                                        (canEdit == true && !(curRole == 'VP' || curRole == 'FIN' || curRole == 'BA' || curRole == 'BAL')) &&
                                        <Button
                                            type="primary"
                                            style={{ float: 'right' }}
                                            onClick={this.addHospital}
                                            disabled={curRole == 'CRC' && userId == id}
                                        >
                                            添加
                                        </Button>
                                    }
                                </div>
                            </div>
                        </li>
                        <li >
                            <Table
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.index}
                                loading={loading}
                                onChange={this.handleTableChange}
                                scroll={{ x: 940, y: 500 }}
                                pagination={pagination}
                            />
                        </li>
                    </ul>
                </div>
                <AddResponseHospital ref={el => { this.addResponseHospitalRef = el; }} loadData={this.loadData} />
            </Modal>
        );
    }
}

export default PreviewHospitalModal;



// WEBPACK FOOTER //
// ./src/components/hospital/ssu/PreviewModal.js